import { IResourceComponentsProps, useExport } from '@pankod/refine-core'

import {
  List,
  RefreshButton,
  CreateButton,
  ExportButton,
  Table,
  Space,
  EditButton,
  DeleteButton,
  DateField,
  getDefaultSortOrder,
  useModalForm,
  Icons,
  Divider,
  Input,
  Button,
  useTable,
  Form
} from '@pankod/refine-antd'
// import { useTable } from '@pankod/refine-core'
import { ICheckList, IStrand } from 'interfaces'
import { CreateCheckList } from './create'
import { EditCheckList } from './edit'
import { useState } from 'react'
import { exportToExcel } from 'exportToExcel'
const { PlusOutlined } = Icons

export const CheckList: React.FC<IResourceComponentsProps> = () => {
  const [pagination,setHasPagination]=useState<any>(true)
  const {tableProps ,searchFormProps, sorter, tableQueryResult,setFilters } = useTable<ICheckList>({
    hasPagination:pagination,
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData: {
      fields: ['id', 'name', 'created_at'],
    },
    onSearch: (values:any) => {
      return [
          {
              field: "name",
              operator: "contains",
              value:`%${values.title}%`,
          },
      ];
  },
  })
  const {tableQueryResult:exportData } = useTable<ICheckList>({
    initialSorter: [
      {
        field: 'created_at',
        order: 'desc',
      },
    ],
    metaData: {
      fields: ['id', 'name', 'created_at'],
    },
  })
  const { formProps, modalProps, show } = useModalForm({
    resource: 'check_lists',
    action: 'create',
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
  } = useModalForm({
    resource: 'check_lists',
    action: 'edit',
    metaData: {
        fields: ['id', 'name', 'created_at'],
    },
  })

  // const { triggerExport, isLoading } = useExport<ICheckList>()

  
  const triggerExport=()=>{
    exportToExcel(exportData?.data?.data,`CheckList_${Math.round(new Date().getTime() / 1000)}.xlsx`)
  }
  return (
    <List
      pageHeaderProps={{
        extra: [
          //  <ExportButton onClick={triggerExport} loading={isLoading} />,
          <RefreshButton onClick={() => tableQueryResult?.refetch()} />,
          <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => show()} />,
          <Button onClick={triggerExport}>Export</Button>
        ],
      }}
    >
       <Form {...searchFormProps}>
        <Space>
            <Form.Item name="title">
                <Input placeholder="Search by title" allowClear  onChange={(e)=>{
                            if(e.type==='click'){
                              searchFormProps.form?.submit()
                            }}}/>
            </Form.Item>
            <Button icon={<Icons.SearchOutlined/>} onClick={searchFormProps.form?.submit} >Search</Button>
        </Space>
    </Form>
    <Divider/>
      <Table {...tableProps} >
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column
          dataIndex="created_at"
          title="Created At"
          render={value => <DateField value={value} format="LLL" />}
          defaultSortOrder={getDefaultSortOrder('created_at', sorter)}
          sorter
        />
        <Table.Column<ICheckList>
          title="Actions"
          dataIndex="actions"
          render={(_, record) => (
            <Space>
              <EditButton size="small" type="link" icon={null} recordItemId={record.id} onClick={() => editShow(record.id)} />
              <DeleteButton size="small" type="link" icon={null} recordItemId={record.id} />
            </Space>
          )}
        />
      </Table>
      <CreateCheckList modalProps={modalProps} formProps={formProps} />
      <EditCheckList modalProps={editModalProps} formProps={editFormProps} />
    </List>
  )
}
